import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import * as css from './TicketDetails.css';

interface TicketDetailsStubProps {
    onMoreInfo: () => void;
}

function TicketDetailsStub({onMoreInfo}: TicketDetailsStubProps) {
    const {t} = useTranslation('eTicket');

    return (
        <css.stub>
            <Button
                variant="neutral"
                size="chip"
                onClick={onMoreInfo}
                data-cy="more-info-button">
                {t('moreInfo')}
            </Button>
        </css.stub>
    );
}

export default TicketDetailsStub;
